import { DESKTOP_BREAKPOINT } from '../default-modules/default-variables';
import { addCategoryIcons, buildNavFromMainMenu, createLogoutMenuItem, createLoginMenuItem, getNavTree } from './menu-utils';

// Constants
const MENU_VERTICAL_MARGIN = 28; // 14px top + 14px bottom
const MEGAMENU_CLOSE_DELAY_MS = 250;
const MENU_TEXT_REPLACEMENTS = {
  Värmepumpstillbehör: 'Värmepumpstillbehör'
};

export function menu() {
  closeAllSubmenus();

  if (window.innerWidth <= DESKTOP_BREAKPOINT) {
    buildMobileMenuStructure();
  }
}

function closeAllSubmenus() {
  const navTree = getNavTree();
  if (!navTree) return;

  $(navTree).removeClass('fw-accordionOpen');
  $(navTree).find('> li > ul').removeClass('fw-accordionOpen');
}

// ========================================
// DESKTOP MEGA MENU
// ========================================

export function megaMenu() {
  const navTree = getNavTree();
  if (!navTree) return;

  buildNavFromMainMenu(navTree, { isMegaMenu: true });
  createMegaMenuExtraMenu();
  moveMainMenuProductSubsToExtra();
  createLoginMenuItem(navTree);
  addCategoryIcons(navTree, { isMegaMenu: true });
  setupMegaMenuHeightAdjustment();
  shortenLongMenuAlternativeNames();
  setupMegaMenuHoverDelay();
}

function setupMegaMenuHoverDelay() {
  const menuItem = document.querySelector('.wl-megamenu-products');
  if (!menuItem) return;

  let closeTimeout = null;

  menuItem.addEventListener('mouseenter', () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
    menuItem.classList.add('wl-megamenu-open');
  });

  menuItem.addEventListener('mouseleave', () => {
    closeTimeout = setTimeout(() => {
      menuItem.classList.remove('wl-megamenu-open');
    }, MEGAMENU_CLOSE_DELAY_MS);
  });
}

function setupMegaMenuHeightAdjustment() {
  const navTree = getNavTree();
  if (!navTree) return;

  $(navTree)
    .find('> li > ul > li')
    .on('mouseenter', function () {
      const megaMenuContainer = $(this).closest('.fw-accordionContent');
      megaMenuContainer.addClass('wl-megamenu');
      megaMenuContainer.css('min-height', '');
      adjustMegaMenuHeight($(this));
    });
}

function adjustMegaMenuHeight(menuItem) {
  const level3Submenu = menuItem.find('> ul.fw-accordionContent');
  if (level3Submenu.length === 0) return;

  const megaMenuContainer = menuItem.closest('.fw-accordionContent');

  const originalBottom = level3Submenu.css('bottom');
  level3Submenu.css('bottom', 'auto');

  const submenuHeight = level3Submenu.outerHeight();

  level3Submenu.css('bottom', originalBottom);

  const containerHeight = megaMenuContainer.height();
  const requiredHeight = submenuHeight + MENU_VERTICAL_MARGIN;

  if (requiredHeight > containerHeight) {
    megaMenuContainer.css('min-height', requiredHeight + 'px');
  }
}

function createMegaMenuExtraMenu() {
  const productMenuItem = document.querySelector('.wl-products-menu-item');
  if (!productMenuItem) return;

  const productSubMenu = productMenuItem.querySelector('ul');
  if (!productSubMenu) return;

  if (productSubMenu.querySelector('.mega-menu-extra')) return;

  const extraMenuHTML = `
    <div class="mega-menu-extra">
      <ul>
      </ul>
    </div>
  `;
  productSubMenu.insertAdjacentHTML('beforeend', extraMenuHTML);
}

function moveMainMenuProductSubsToExtra() {
  const extraMenuContainer = document.querySelector('.mega-menu-extra ul');
  if (!extraMenuContainer) return;

  const productMenuItem = document.querySelector('.wl-products-menu-item');
  if (!productMenuItem) return;

  const productSubMenu = productMenuItem.querySelector(':scope > ul');
  if (!productSubMenu) return;

  // Hitta alla MainMenu produktunderposter (t.ex. Nyheter, Kampanj, Outlet, etc.)
  const mainMenuProductItems = productSubMenu.querySelectorAll('.wl-main-menu-product');

  mainMenuProductItems.forEach((item) => {
    extraMenuContainer.appendChild(item);
  });
}

function shortenLongMenuAlternativeNames() {
  const navTree = getNavTree();
  if (!navTree) return;

  $(navTree)
    .find('> li > ul > li > div > a')
    .each(function () {
      const text = this.textContent.trim();
      if (MENU_TEXT_REPLACEMENTS[text]) {
        $(this).text(MENU_TEXT_REPLACEMENTS[text]);
      }
    });
}

// ========================================
// DESKTOP MENY (chrome: overlay, knappar)
// ========================================

export function desktopMenu() {
  setupLoginMenuButton();
  createMenuOverlay();
  moveNavTreeToMenu();
  autoCloseMenu();
}

function autoCloseMenu() {
  $('#body').removeClass('offcanvas-menu-open menu-toolbar-panel-instant offcanvas-menu-open-user-toolbar');
}

function setupLoginMenuButton() {
  const closeButton = $('#MenuToolbarPanelUserClose > i');
  closeButton.removeClass('fw-icon-left').addClass('fw-icon-cancel');

  $('#UserLoginFlyout')
    .off('click')
    .on('click', function () {
      $('#Menu').addClass('userToolbarOpen');
      $('#menu-overlay').addClass('open');
    });

  $('#MenuToolbarPanelUserClose').on('click', function () {
    $('#menu-overlay').removeClass('open');
    $('#Menu').removeClass('userToolbarOpen');
  });
}

function createMenuOverlay() {
  if ($('#menu-overlay').length) return;

  const overlay = $('<div id="menu-overlay" class="offcanvas-overlay wl-added"></div>');
  $('#OffcanvasCartOverlay').after(overlay);

  $('#UserTabToggle').on('click', () => {
    overlay.toggleClass('open');
  });

  overlay.on('click', () => {
    overlay.removeClass('open');
    $('#Menu').removeClass('userToolbarOpen settingsToolbarOpen');
  });
}

function moveNavTreeToMenu() {
  const navTree = $('#Tree');
  const target = $('#OpenMenuContent');

  if (!navTree.length || !target.length) return;
  if (target.find('#Tree').length) return;

  navTree.detach().appendTo(target);
}

// ========================================
// MOBIL MENY
// ========================================

function buildMobileMenuStructure() {
  const navTree = getNavTree();
  if (!navTree) return;

  buildNavFromMainMenu(navTree, { isMegaMenu: false });
  createLoginMenuItem(navTree);
  addCategoryIcons(navTree, { isMegaMenu: false });
}
